import React from "react";

import { Button } from "@app/scripts/react-general-components/Button";

import type { AuthStates } from "@app/scripts/types";

type Props = {
  content: any;
  switchForm: React.Dispatch<React.SetStateAction<AuthStates>>;
  bannerImage: JSX.Element;
};

export const AccountLoginForm: React.FC<Props> = ({ content, switchForm, bannerImage }) => (
  <>
    {bannerImage}

    <ui-form>
      <form
        method="post"
        action="/account/login"
        id="customer_login_drawer"
        accept-charset="UTF-8"
        data-login-with-shop-sign-in="true"
        noValidate
      >
        <input type="hidden" name="form_type" value="customer_login" />

        <div className="_field">
          <input
            type="email"
            name="customer[email]"
            className="_field__input"
            id="CustomerEmail_drawer"
            autoComplete="email"
            autoCapitalize="off"
            required
            placeholder={content?.login_page?.email}
          />
          <label htmlFor="CustomerEmail_drawer" className="_field__label">
            {content?.login_page?.email}
          </label>
        </div>

        <div className="_field">
          <input
            type="password"
            className="_field__input"
            name="customer[password]"
            id="CustomerPassword_drawer"
            autoComplete="current-password"
            required
            placeholder={content?.login_page?.password}
          />
          <button
            className="_field__button"
            aria-label="form button"
            data-showpassword="CustomerPassword_drawer"
            type="button"
          >
            <ui-icon name="icon-eye-off"></ui-icon>
          </button>
          <label htmlFor="CustomerPassword_drawer" className="_field__label">
            {content?.login_page?.password}
          </label>
        </div>

        <Button
          type="button"
          onClick={() => switchForm("recover")}
          variant="text"
          className="login__forgot-btn"
          label={content?.login_page?.forgot_password}
        />

        <Button
          type="submit"
          variant="secondary"
          className="login__submit-btn fullwidth"
          label={content?.login_page?.sign_in_desktop}
        />
      </form>

      <div className="login__create">
        <span
          className="text-md text-brand-secondary-grey"
          dangerouslySetInnerHTML={{ __html: content?.login_page?.create_text }}
        />

        <Button
          onClick={() => switchForm("create")}
          variant="text"
          className="login__forgot-btn"
          label={content?.login_page?.create_account}
        />
      </div>
    </ui-form>
  </>
);
